export const NETWORK_FAILURE_MESSAGE = "Couldn't reach Alphamizer. Check your internet connection and try again.";

// The TypeError messages fetch() rejects with when no response arrives:
// Chromium, Firefox, Safari 17+ and earlier Safari. Chromium rejects with
// 'network error' when the connection drops while the response body is read.
const FETCH_FAILURE_MESSAGES = new Set([
    'Failed to fetch',
    'NetworkError when attempting to fetch resource.',
    'Load failed',
    'The Internet connection appears to be offline.',
    'network error',
]);

// Firebase's code when it cannot refresh the ID token a backend call sends.
const FIREBASE_NETWORK_FAILURE_CODE = 'auth/network-request-failed';

/**
 * True when a backend call failed without a response: fetch() rejected with
 * its own TypeError, Firebase could not refresh the ID token, or the browser
 * reports it is offline. A cancelled request (AbortError) and an HTTP error
 * response (BackendHttpError) are not network failures.
 */
export function isNetworkFailure(error) {
    if (!(error instanceof Error) || ['AbortError', 'BackendHttpError'].includes(error.name)) {
        return false;
    }
    if (error.name === 'TypeError' && FETCH_FAILURE_MESSAGES.has(error.message)) {
        return true;
    }
    if (error.code === FIREBASE_NETWORK_FAILURE_CODE) {
        return true;
    }
    return typeof navigator !== 'undefined' && navigator.onLine === false;
}
